/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SuepChangeModelModalAliases {
  DECK_MODAL_OPTIONS = 'deck-modal-options',
  FETCH_MODAL_OPTIONS = 'fetch-modal-options',
  LAYOUT_CHANGE_MODEL = 'layout-change-model',
  LAYOUT_MODAL = 'layout-modal',
  MODAL_OPTIONS_CARD = 'modal-options-card',
  PANEL_MODAL = 'panel-modal',
}
export { SuepChangeModelModalAliases };
